module.exports = __webpack_public_path__ + "static/media/esen.4b1b1ce9.jpg";